import { ca } from '@cian/analytics';

export function trackLabelClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label,
    useLastProducts: true,
  });
}
